<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.po") }}
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button size="md" type="neutral" @click="handleCreate()">{{ $t("new") }}</base-button>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">

                            <div class="col-md-2 col-xs-12">
                                <base-input class="">
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                        :config="{ allowInput: true }" :placeholder="$t('time_from')"
                                        class="form-control datepicker" v-model="params.time_from">
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input>
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                        :config="{ allowInput: true }" :placeholder="$t('time_to')"
                                        class="form-control datepicker" v-model="params.time_to">
                                    </flat-picker>
                                </base-input>
                            </div>


                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
                                    <i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button>
                                <base-button size="md" :loading="isLoading" @click="handleExport()"
                                    v-if="isSearchAdvance">
                                    Export</base-button>
                                <base-button size="md" :loading="isExportLoading" @click="handleExportDetail()"
                                    v-if="isSearchAdvance"> Export Detail</base-button>
                            </div>
                        </div>


                    </template>
                    <!-- end header -->

                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light">
                            <!-- order_number -->
                            <el-table-column align="left" :label="$t('po_number')" min-width="80px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.po_number }} </span>

                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column align="left" :label="$t('partner_name')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.partner_name }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('staff')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.user_full_name }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('date')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.po_date }} </span>
                                </div>
                            </el-table-column>



                            

                            <el-table-column align="right" :label="$t('actions')" min-width="120px">
                                <div slot-scope="{ $index, row }" class="d-flex">

                                    <base-button @click.native="
                                        handleDetail(row)
                                        " class="edit" type="warning" size="sm" icon>
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>

                                    <base-button 
                                        @click.native="handleChangeShipping(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fas fa-shipping-fast"></i>
                                    </base-button>


                                    <base-button @click.native=" handleDelete($index, row)" class="remove btn-link"
                                        type="danger" size="sm" icon >
                                        <i class="text-dtac-bt fa fa-trash text-white"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "PO/getData",
            isLoading: "PO/isLoading",

            isAdmin: "Auth/isAdmin",
            isOwner: "Auth/isOwner",
            isEmployee: "Auth/isEmployee",
            isAgent: "Auth/isAgent",
        }),



    },
    data() {
        return {
            propsToSearch: ["po_number", "partner_name", "user_full_name"],
            selectedRows: [],
            params: {
                time_from: "",
                time_to: "",
            },
            isExportLoading: false,

        };
    },
    async mounted() {
        this.params.time_from = moment().subtract(40, 'days').format('YYYY-MM-DD');
        this.params.time_to = moment().format('YYYY-MM-DD');

        this.listData(this.params);

    },
    methods: {
        ...mapActions({
            createData: "PO/createData",
            updateData: "PO/updateData",
            deleteData: "PO/updateData",
            listData: "PO/listData",
            getDetail: "PO/getDetail",
            duplicate: "PO/duplicate",
            getFile: "PO/getFile",
            approve: "PO/approve",
            cancel: "PO/cancel",
            patialclose: "PO/paialclose",
            close: "PO/close",

        }),
        handleSearch() {
            this.listData(this.params);
        },
        handleDetail(row) {
            // go to po page
            this.showDetailModal = true;
            this.orderDetail = row;
            console.log(this.orderDetail)
            this.listDatum({ id: row.ID });
            //
        },

        handleCreate() {
            this.$router.push("/backoffice/po/create");
        },

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
